import styled from 'styled-components';
import { ButtonProps } from '@fluentui/react-components';
import { RequestDetailsPrimaryButton } from '../../requestDetailsCancelPopupContainer/styles/RequestDetailsCancelPopup.styled';
import { SecondaryButton } from 'src/styles/globalStyles/buttonStyles.styled';

export const RequestDetailsContainerStyle = styled.div`
  background: ${(props) => props.theme.mainBackgorund};
  left: 50%;
  width: 33rem;
  padding: 1em;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;

  @media (max-width: 710px) {
    height: 100%;
    width: 100%;
    padding: 0;
  }
`;

export const RequestDetailsContentContainer = styled.div`
  padding: 0.2rem 0.5em;

  @media (max-width: 710px) {
    padding: 17px 25px;
    height: 90vh;
    overflow-y: scroll;
  }
`;

export const RequestDetailsContainerDivider = styled.div`
  height: 2px;
  width: 100%;
  margin: 1rem 0;
  background: ${(props) => props.theme.dividerMainColor};
`;

export const RequestDetailsCloseButton = styled(SecondaryButton)<ButtonProps>`
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  border-radius: 4px;
  padding: 0px 12px;
  height: 32px;

  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.11);

  @media (max-width: 710px) {
    display: none;
  }
`;

export const CancelButton = styled(RequestDetailsPrimaryButton)`
  display: block;
  margin-left: auto;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
